import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isEstablishingConnection: false,
  isConnectionEstablished: false,
  isConnectionError: false
};

const notificationsSlice = createSlice({
  initialState,
  name: 'notifications',
  reducers: {
    establishConnectionStart(state) {
      state.isEstablishingConnection = true;
      state.isConnectionEstablished = false;
      state.isConnectionError = false;
    },
    establishConnectionSuccess(state) {
      state.isEstablishingConnection = false;
      state.isConnectionEstablished = true;
      state.isConnectionError = false;
    },
    establishConnectionFail(state) {
      state.isEstablishingConnection = false;
      state.isConnectionEstablished = false;
      state.isConnectionError = true;
    },
    disconnect(state) {
      state.isEstablishingConnection = false;
      state.isConnectionEstablished = false;
      state.isConnectionError = false;
    }
  }
});

export const notificationsActions = notificationsSlice.actions;

export default notificationsSlice.reducer;
